import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import FlexRow from '../../../../../molecules/FlexRow'
import { useFormattingContext } from '../../../../../organisms/FormattingProvider/FormattingContext'

dayjs.extend(utc)

function MessageHeader ({ role, agentLabel, createdDate }) {
  const { formatter } = useFormattingContext()

  return (
    <FlexRow className='justify-between' style={{ borderBottom: role === 'user' ? undefined : 'var(--border-neutral-thin)' }}>
      <span style={{ color: role === 'user' ? undefined : 'var(--color-ai-600)' }}>
        {role === 'user' ? 'You' : (agentLabel || 'Assistant')}
      </span>
      <span>{formatter(dayjs.utc(createdDate), '&h:mm a')}</span>
    </FlexRow>
  )
}

MessageHeader.propTypes = {
  role: PropTypes.string.isRequired,
  agentLabel: PropTypes.string,
  createdDate: PropTypes.string
}

export default MessageHeader
